import React, { useState } from 'react';
import { bool, func, object } from 'prop-types';
import { UserMenuHandle } from '../types/enums';
import { ROUTE_PROFILE } from 'constants/routerPath';
import { Link } from 'react-router-dom';
import Logout from '@mui/icons-material/Logout';
import Settings from '@mui/icons-material/Settings';
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { URL_LOGOUT } from 'constants/urls';
import { resetCanTabState } from '../libs/useLocalStorage';
import Preferences from './Preferences';
import styleMenu from '../styles/styleMenu';

/**
 * @component UserMenu
 * @desc UserMenu component represents a dropdown menu with user-related actions and preferences.
 * @param {Object} props
 * @param {boolean} props.openMenu
 * @param {object} props.anchorEl
 * @param {function} props.onClose
 * @returns {JSX.Element}
 */
function UserMenu({ openMenu, anchorEl, onClose }) {
	const [openPrefer, setOpenPrefer] = useState(false);

	const onHandleOpen = (name) => {
		if (name === UserMenuHandle.OpenPrefer) {
			setOpenPrefer(true);
		} else if (name === UserMenuHandle.ClosePrefer) {
			setOpenPrefer(false);
		}
	};

	return (
		<Menu
			anchorEl={anchorEl}
			open={openMenu}
			onClose={onClose}
			PaperProps={{ ...styleMenu, 'data-tour': 'nav-profile-menu' }}
			transformOrigin={{ horizontal: 'left', vertical: 'top' }}
			anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
		>
			<MenuItem component={Link} to={ROUTE_PROFILE} onClick={onClose}>
				<ListItemIcon>
					<Avatar />
				</ListItemIcon>
				Profile
			</MenuItem>
			<Divider />
			<MenuItem onClick={() => onHandleOpen(UserMenuHandle.OpenPrefer)}>
				<ListItemIcon>
					<Settings fontSize="small" />
				</ListItemIcon>
				Preferences
			</MenuItem>
			<MenuItem component="a" href={URL_LOGOUT} onClick={resetCanTabState}>
				<ListItemIcon>
					<Logout fontSize="small" />
				</ListItemIcon>
				Logout
			</MenuItem>
			{openPrefer && <Preferences open={openPrefer} onHandleOpen={onHandleOpen} />}
		</Menu>
	);
}

UserMenu.propTypes = {
	openMenu: bool,
	anchorEl: object,
	onClose: func,
};

export default UserMenu;
